// extracted by mini-css-extract-plugin
module.exports = {"button":"loadMoreButton_button__1f7ye","arrowDown":"loadMoreButton_arrowDown__PU3Da","spinner":"loadMoreButton_spinner__3OOsH"};